import React from 'react';

import { HomeContentEntity } from '../../domain/entities/HomeContentEntity';

import styles from '../styles/HomeBannerWrapper.module.scss';

import HomeBannerImageCmp from './HomeBannerImageCmp';
import HomeBannerTextCmp from './HomeBannerTextCmp';

interface HomeBannerWrapperCmpProps {
  data: HomeContentEntity;
}

function HomeBannerWrapperCmp({
  data,
}: HomeBannerWrapperCmpProps): React.ReactElement {
  return (
    <div className={styles['banner-wrapper']}>
      <HomeBannerImageCmp
        desktopBanner={data.banner.banner_image.path}
        mobileBanner={data.banner.banner_img_mobile.path}
      />
      <div className={styles['banner-overlay']} />
      <div className={styles['desktop-only']}>
        <HomeBannerTextCmp
          title={data.banner.banner_text}
          description={data.banner.banner_subtext}
        />
      </div>
      <div className={styles['mobile-only']}>
        <HomeBannerTextCmp
          title={data.banner.banner_text}
          description={data.banner.banner_subtext}
        />
      </div>
    </div>
  );
}

export default HomeBannerWrapperCmp;
